import React, { useState } from 'react';
import { Card } from '@zillow/constellation';
import { ePermissions } from '../../../types/administration/userAdministration/ePermissions';
import { IAdminUserData } from '../../../types/administration/userAdministration/IAdminUser';
import { AdminUsersSearchTable } from './AdminUsersSearchTable';
import { EditAdminUserForm } from './EditAdminUserForm';
import { EditUserProfileForm } from './EditUserProfileForm';
import { AccessControlCheck } from 'components/accessControl/AccessControlCheck';
import { ErrorBoundaryConstellation } from '../../../constellationExtended/ErrorBoundary/ErrorBoundaryConstellation';

export const AdminUsersContainer: React.FC = () => {
  const [editAdminUser, setEditAdminUser] = useState<null | IAdminUserData>(null);
  const [editProfileUser, setEditProfileUser] = useState<null | IAdminUserData>(null);

  const handleCloseEditAdmin: React.Dispatch<React.SetStateAction<boolean>> = (value) => {
    const shouldClose = typeof value === 'function' ? !value(!!editAdminUser) : !value;
    if (shouldClose) setEditAdminUser(null);
  };
  
  const handleCloseEditProfile: React.Dispatch<React.SetStateAction<boolean>> = (value) => {
    const shouldClose = typeof value === 'function' ? !value(!!editProfileUser) : !value;
    if (shouldClose) setEditProfileUser(null);
  };

  return (
    <AccessControlCheck allowedPermissions={[ePermissions.AuthIdentityRead]}>
      <ErrorBoundaryConstellation>
        <Card cardType="secondary" cardElevation={1} data-test-id="administration-users-page">
          <AdminUsersSearchTable 
            setUpdateAdminUser={setEditAdminUser} 
            setUpdateUserProfile={setEditProfileUser}
          />
          <EditAdminUserForm 
            adminUser={editAdminUser} 
            open={!!editAdminUser} 
            setOpen={handleCloseEditAdmin} 
          />
          <EditUserProfileForm 
            adminUser={editProfileUser} 
            open={!!editProfileUser} 
            setOpen={handleCloseEditProfile} 
          />
        </Card>
      </ErrorBoundaryConstellation>
    </AccessControlCheck>
  );
};
